// extracted by mini-css-extract-plugin
export var parcelRow = "_s9-0";